import { FileServiceError } from "./FileServiceError";

export class FileServiceMinSizeError extends FileServiceError {
  readonly minSize: number;
  readonly fileSize?: number;

  constructor(message: string, minSize: number, fileSize?: number) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "FileServiceMinSizeError";
    this.minSize = minSize;
    this.fileSize = fileSize;
  }
}
